// ATTENTION!
// While the animate-on-scroll module still uses reveal.js themed
// attributes/class names/custom properties, the actual reveal.js library
// is no longer used due to buggy behavior.

const delayingElements = new Map()

// Create an observer to notice when elements become visible
const observer = new IntersectionObserver(entries => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      // Only need to observe elements until in viewport once -> unobserve now
      observer.unobserve(entry.target)

      let endHandler = event => {
        if (event.target === entry.target) {
          delayingElements.get(entry.target.dataset.revealGroup).delete(entry.target)
          entry.target.removeEventListener('transitionend', endHandler)

          delete entry.target.dataset.reveal
          delete entry.target.dataset.revealGroup
          entry.target.classList.remove('reveal-animate')
          entry.target.style.removeProperty('--reveal-offset')
          entry.target.style.removeProperty('--reveal-delay')
        }
      }
      entry.target.addEventListener('transitionend', endHandler)

      if (!('revealConcurrent' in entry.target.dataset)) {
        if (!delayingElements.has(entry.target.dataset.revealGroup)) {
          delayingElements.set(entry.target.dataset.revealGroup, new Set())
        }

        delayingElements.get(entry.target.dataset.revealGroup).add(entry.target)
      }

      entry.target.style.setProperty(
        '--reveal-offset',
        String(delayingElements.get(entry.target.dataset.revealGroup).size),
      )

      entry.target.classList.add('reveal-animate')
    }
  }
})

const selector = '[data-reveal]:not([data-skip-reveal], [data-skip-reveal] *)'
document.querySelectorAll(selector).forEach(element => {
  // Conditions may have changed as part of the steps below
  if (!element.matches(selector)) return

  // Remove [data-reveal] from elements that have already initially been scrolled over
  // to avoid animating elements above the initial viewport.
  // This is mostly relevant for browser forward/back navigation
  // where the scroll position is remembered.
  // Also remove [data-reveal] from elements that are inside a swiper as those are
  // dynamically inserted into the DOM which causes problems with revealing them.
  // if (element.getBoundingClientRect().bottom <= 0 || element.matches('.swiper *')) {
  if (element.getBoundingClientRect().bottom <= 0) {
    element.removeAttribute('data-reveal')
    element.querySelectorAll('[data-reveal]').forEach(descendant => {
      descendant.removeAttribute('data-reveal')
    })

    return
  }

  element.dataset.revealGroup = element.dataset.revealGroup ?? 'default'

  // Handle the element with the observer
  observer.observe(element)
})

// After intercepting, remove reveal attributes
document.addEventListener('after-intercept', event => {
  // On next mutation, remove all reveal attributes
  const observer = new MutationObserver(entries => {
    observer.disconnect()

    event.target.querySelectorAll('[data-reveal]').forEach(element => {
      delete element.dataset.reveal
    })
  })
  observer.observe(event.target, { childList: true, subtree: true })
})
